// src/pages/Admin/AdminCustomersPage.jsx
import React, { useEffect, useState } from "react";
import { adminService } from "../../services/admin.service";
import "./adminCustomers.css";

const AdminCustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");

  const loadCustomers = async () => {
    try {
      setError("");
      const data = await adminService.getCustomers();
      const customerList = Array.isArray(data)
        ? data
        : data.customers || [];

      setCustomers(customerList);
      setFilteredCustomers(customerList);
    } catch (err) {
      console.error(err);
      setError("Failed to load customers");
    }
  };

  useEffect(() => {
    loadCustomers();
  }, []);

  // 🔎 Search Function
  useEffect(() => {
    const filtered = customers.filter((c) =>
      `${c.first_name} ${c.last_name} ${c.email} ${c.phone_number}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
    setFilteredCustomers(filtered);
  }, [searchTerm, customers]);

  return (
    <div className="admin-customers-page">
      <div className="admin-page-header">
        <h2>Customers</h2>
        <div className="customer-summary">
          Total Customers: <strong>{customers.length}</strong>
        </div>
      </div>

      {/* 🔎 Search Bar */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by name, email or phone..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {error && <div className="error-msg">{error}</div>}

      <div className="table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>User ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Joined</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomers.map((c) => (
              <tr key={c.user_id}>
                <td>{c.user_id}</td>
                <td>
                  {c.first_name} {c.last_name}
                </td>
                <td>{c.email}</td>
                <td>{c.phone_number}</td>
                <td>
                  {c.createdAt
                    ? new Date(c.createdAt).toLocaleDateString()
                    : "-"}
                </td>
                <td>
                  <span className="status-badge active">
                    Active
                  </span>
                </td>
              </tr>
            ))}

            {filteredCustomers.length === 0 && (
              <tr>
                <td colSpan={6} className="no-data">
                  No customers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCustomersPage;